// extracted by mini-css-extract-plugin
export default {"container":"uZ-z","heading":"vZ-z","links":"wZ-z","copy":"xZ-z","subCopy":"yZ-z","linksLeft":"zZ-z","linksCenter":"AZ-z","linksRight":"BZ-z","link":"CZ-z","onlyLink":"DZ-z"};